// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.small-label {
  display: block;
  font-size: 0.75rem;
  line-height: 1.1;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: var(--ion-color-medium, #92949c);
  margin-bottom: 0.125rem;
}

.movimento-row + .movimento-row {
  margin-top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/movimenti/movimento-trasferimento/movimento-trasferimento.component.scss"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uCAAA;EACA,uBAAA;AAAF;;AAIA;EACE,kBAAA;AADF","sourcesContent":["// Etichetta compatta per i campi della riga articolo (layout unico responsive).\n.small-label {\n  display: block;\n  font-size: 0.75rem;\n  line-height: 1.1;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  color: var(--ion-color-medium, #92949c);\n  margin-bottom: 0.125rem;\n}\n\n// Spaziatura tra le righe articolo dell'elenco di trasferimento.\n.movimento-row + .movimento-row {\n  margin-top: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
